module.exports = __webpack_public_path__ + "static/img/reportH5.d13fa22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reportH5.png
// module id = YaA+
// module chunks = 0